import ObjArrUtils from '@/utils/ObjArrUtils'
import moment from 'moment'

function checkRequiredParams(params) {
  Object.keys(params).forEach(key => {
    if (params[key] === undefined || params[key] === null) {
      throw new Error(`C30101ScheduleTableDataParser: Missing required parameter: ${key}`)
    }
  })
}

export function C30101ScheduleTableDataParser({
  t1030_entry_schedule_week,
  t1031_entry_schedule,
  t1032_not_attended_schedule,
  t3010_schedule,
  t3013_change_schedule,
  t3015_cancel_schedule,
  t0062_entry_control,
  t0063_regular_schedule_control,
  C30101_getCalender,
  C30101_getCellTeacherCount,
  classStartDate,
  classEndDate,
  calendarTimeSlot,
}) {
  checkRequiredParams({
    t1030_entry_schedule_week,
    t1031_entry_schedule,
    t1032_not_attended_schedule,
    t3010_schedule,
    t3013_change_schedule,
    t3015_cancel_schedule,
    t0062_entry_control,
    t0063_regular_schedule_control,
    C30101_getCalender,
    C30101_getCellTeacherCount,
    classStartDate,
    classEndDate,
    calendarTimeSlot,
  })

  let scheduleData = {}
  const startDate = classStartDate
  // get end date from C30101_getCalender
  const endDate = C30101_getCalender.reduce((max, day) => {
    const dayMoment = moment(day.schedule_date)
    return dayMoment.isAfter(max) ? dayMoment : max
  }, moment(classEndDate))


  function insertOrUpdate(timeKey, input) {
    if (scheduleData[timeKey]) {
      scheduleData[timeKey] = {
        ...scheduleData[timeKey],
        ...input
      }
    } else {
      scheduleData[timeKey] = input
    }
  }
  function insertData(timeKey, obj) {
    if (scheduleData[timeKey]) {
      scheduleData[timeKey].data = {
        ...scheduleData[timeKey].data,
        ...obj
      }
    } else {
      scheduleData[timeKey] = {
        label: '',
        render: '',
        data: {
          ...obj
        }
      }
    }
  }

  C30101_getCalender?.forEach(day => {
    const dayMoment = moment(day.schedule_date)
    if (!dayMoment.isBetween(startDate, endDate, null, '[]')) return;
    for (const slot of calendarTimeSlot) {
      const timeKey = `${day.schedule_date}_${slot.time_limit_no}`
      const inTimelimit = (slot.time_limit_no >= day.tstart_ime_limit_no && slot.time_limit_no <= day.end_time_limit_no)
      if (day.closed_flag === 1 || !inTimelimit) {
        insertOrUpdate(timeKey, {
          label: '－',
          render: 'closed',
        })
        insertData(timeKey, {
          closed: true,
          teacherCount: 0,
          isFullyBooked: true,
        })
      } else {
        insertOrUpdate(timeKey, {
          label: '',
          render: '',
        })
        insertData(timeKey, {
          closed: false,
          teacherCount: 0,
          isFullyBooked: true,
        })
      }
      scheduleData[timeKey] = ObjArrUtils.merge(scheduleData[timeKey], {
        props: {
          teacherCount: 0,
          isFullyBooked: true,
        }
      })
    }
  })

  /**
   * {key}: object
   */
  Object.keys(C30101_getCellTeacherCount)?.forEach(key => {
    const timeKey = key
    const entry = C30101_getCellTeacherCount[key]
    const netCount = Number(entry.rem_teacher_cnt)
    if(scheduleData[timeKey]?.data?.closed) return // skip closed cells
    insertData(timeKey, {
      teacherCount: netCount,
      isFullyBooked: netCount <= 1,
    })
    scheduleData[timeKey] = ObjArrUtils.merge(scheduleData[timeKey], {
      props: {
        teacherCount: netCount,
        isFullyBooked: netCount <= 1,
      }
    })
  })
  t0062_entry_control?.forEach(entry => {
    const timeKey = `${entry.schedule_date}_${entry.time_limit_no}`
    insertData(timeKey, {
      entryControl: true,
    })
    scheduleData[timeKey] = ObjArrUtils.merge(scheduleData[timeKey], {
      props: {
        entryControl: true,
      }
    })
  })

  function handleCourse() {
    const courseMap = {}

    // Process t3010_schedule (Actual schedule)
    t3010_schedule?.forEach(schedule => {
      if (schedule._action === 'del') return;
      const scheduleDate = moment(schedule.schedule_date)
      if (!scheduleDate.isBetween(startDate, endDate, null, '[]')) return;
      const timeKey = `${schedule.schedule_date}_${schedule.time_limit_no}`
      const changeEntry = t3013_change_schedule?.find(
        t3013 => t3013.schedule_no === schedule.schedule_no
      )

      // Override existing data
      if (courseMap[timeKey]) {
        window.vue.$dialog.notify.error(`Duplicate t3010_schedule entry for ${timeKey}`);
      } else {
        courseMap[timeKey] = {
          label: schedule.subject_name,
          data: {
            t3010: schedule,
            t3013: changeEntry || undefined
          },
          render: changeEntry ? 't3013' : 't3010'
        }
      }
    })

    // Process t1030_entry_schedule_week (Regular classes)
    t1030_entry_schedule_week?.forEach(schedule => {
      if (schedule._action === 'del') return;
      if (schedule.delete_flag === 1) return;

      const courseEndDate = schedule.course_end_date === '9999-12-31' ? endDate : moment(schedule.course_end_date)
      
      // dirty fix data for t1030_entry_schedule_week before 2025-06-23 has wrong start of week date
      // the StartofWeekDateString in t1030_entry_schedule_week is supposed to be the Monday of that week
      // for other system (WAM) no problem,because it direct using dayofweek_code to calculate the date
      function convert(StartofWeekDateString,dayOfWeekCode) {
        const date = moment(StartofWeekDateString)
        // if StartofWeekDateString is not monday, throw error
        if(date.day() !== 1) {
          let newStartofWeekDateString = date.clone().add(1, 'day').format('YYYY-MM-DD')
          console.log(`Warning: Start of week date ${StartofWeekDateString} is not Monday, but ${date.format('dddd')}. Adjusting to next Monday.`, newStartofWeekDateString)
          return convert(newStartofWeekDateString, dayOfWeekCode)
        }
        
        return date.add(dayOfWeekCode, 'day')
      }
      
      // Generate all dates for this regular schedule within the range
       const currentDate = convert(schedule.course_start_date, schedule.dayofweek_code)
      const endDateLimit = courseEndDate
       
      while (currentDate.isSameOrBefore(endDateLimit)) {
        if (currentDate.day() - 1 === schedule.dayofweek_code) {
          const dateKey = currentDate.format('YYYY-MM-DD')
          const timeKey = `${dateKey}_${schedule.time_limit_no}`

          const dayEntry = C30101_getCalender?.find(
            day => day.schedule_date === dateKey
          )
          if (dayEntry?.closed_flag === 1) {
            currentDate.add(7, 'day')
            continue
          }

          // if any t1032_not_attended_schedule has entry_schedule_no equal to schedule.id, skip
          const notAttendEntry = t1032_not_attended_schedule?.find(
            t1032 => t1032.entry_schedule_no === schedule.entry_schedule_no
              && t1032.schedule_date === currentDate.format('YYYY-MM-DD')
              && t1032.time_limit_no === schedule.time_limit_no
          )
          if (notAttendEntry) {
            currentDate.add(7, 'day')
            continue
          };

          // if any t3013_change_schedule has entry_schedule_no equal to schedule.id, skip
          const changeEntry = t3013_change_schedule?.find(
            t3013 => t3013.entry_schedule_no === schedule.entry_schedule_no
              && t3013.schedule_date === currentDate.format('YYYY-MM-DD')
              && t3013.time_limit_no === schedule.time_limit_no
          )
          if (changeEntry) {
            currentDate.add(7, 'day')
            continue
          };

          const removeEntry = t3015_cancel_schedule?.find(
            t3015 => t3015.entry_schedule_no === schedule.entry_schedule_no
              && t3015.schedule_date === currentDate.format('YYYY-MM-DD')
              && t3015.time_limit_no === schedule.time_limit_no
          )
          if (removeEntry) {
            currentDate.add(7, 'day')
            continue
          };

          const regularOffday = t0063_regular_schedule_control?.find(
            t0063 => t0063.schedule_date === currentDate.format('YYYY-MM-DD')
          )
          if (regularOffday) {
            currentDate.add(7, 'day')
            continue
          };

          if (courseMap[timeKey]) {
            courseMap[timeKey].data.t1030 = schedule
            courseMap[timeKey].render = 't1030'
          } else {
            courseMap[timeKey] = {
              label: schedule.subject_name,
              render: 't1030',
              data: {
                t1030: schedule
              }
            }
          }
        }
        currentDate.add(7, 'day')
      }
    })

    // Process t1031_entry_schedule (Single classes), will be overlapped with t3010_schedule
    t1031_entry_schedule?.forEach(schedule => {
      if (schedule.delete_flag === 1 || schedule._action === 'del') return;
      const scheduleDate = moment(schedule.schedule_date)
      if (!scheduleDate.isBetween(startDate, endDate, null, '[]')) return;
      const timeKey = `${schedule.schedule_date}_${schedule.time_limit_no}`

      if (courseMap[timeKey]) {
        courseMap[timeKey].data.t1031 = schedule
        switch (schedule.class_type) {
          case 2:
            courseMap[timeKey].render = 't1031_2'
            break;
          case 3:
            courseMap[timeKey].render = 't1031_3'
            break;
          default:
            alert('Problem, unknown class_type')
            break;
        }
      } else {
        window.vue.$dialog.notify.error(`No existing t3010 entry schedule for t1031_entry_schedule on ${timeKey}`);
      }
    })

    // loop all keys, and if timeLimit is divided by 10, convert into 2 entries
    Object.keys(courseMap).forEach(key => {
      const [date, timeLimitNo] = key.split('_')
      if (parseInt(timeLimitNo) % 10 === 0) {
        const topHalfTimeKey = `${date}_${parseInt(timeLimitNo) + 1}`
        const bottomHalfTimeKey = `${date}_${parseInt(timeLimitNo) + 2}`
        if (!courseMap[topHalfTimeKey]) {
          courseMap[topHalfTimeKey] = {
            ...courseMap[key],
            render: courseMap[key].render + '_top',
            relatedKey: bottomHalfTimeKey,
          }
        }
        if (!courseMap[bottomHalfTimeKey]) {
          courseMap[bottomHalfTimeKey] = {
            ...courseMap[key],
            render: courseMap[key].render + '_bottom',
            label: '↑',
            relatedKey: topHalfTimeKey,
          }
        }
      }
    })

    // make all render into props class
    Object.keys(courseMap).forEach(key => {
      const schedule = courseMap[key]
      schedule.props = schedule.props || {}
      schedule.props.class = schedule.render
    })
    return courseMap
  }

  const couseMap = handleCourse.call(this)
  scheduleData = ObjArrUtils.merge(scheduleData, couseMap)

  return scheduleData
}

const C30101ScheduleTableMixin = {
  computed: {
    intermediateScheduleData() {
      return C30101ScheduleTableDataParser({
        t1030_entry_schedule_week: this.t1030_entry_schedule_week,
        t1031_entry_schedule: this.t1031_entry_schedule,
        t1032_not_attended_schedule: this.t1032_not_attended_schedule,
        t3010_schedule: this.t3010_schedule,
        t3013_change_schedule: this.t3013_change_schedule,
        t3015_cancel_schedule: this.t3015_cancel_schedule,
        t0062_entry_control: this.t0062_entry_control,
        t0063_regular_schedule_control: this.t0063_regular_schedule_control,
        C30101_getCalender: this.C30101_getCalender,
        C30101_getCellTeacherCount: this.C30101_getCellTeacherCount,
        classStartDate: this.classStartDate,
        classEndDate: this.classEndDate,
        calendarTimeSlot: $this.$store.getters['Auth/Auth_getTimeLimit_without0'],
      })
    }
  },
}

export {
  C30101ScheduleTableMixin
}
